import type { Map as MapboxMap } from 'mapbox-gl';
import { PRE_PERMIT_HEXAGON_IMAGE } from 'components/map/pre-permit-hexagon';

const INSET_MAIN_WELL_LINE_WIDTH = 0.5;

/** The slice of a mapbox map styleInsetMainWells reads and restyles. */
type InsetMap = Pick<
  MapboxMap,
  'isStyleLoaded' | 'getStyle' | 'setPaintProperty' | 'setLayoutProperty'
>;

/**
 * Restyles the inset's Main Wells (wells-v2) layers for contrast: thins the wellbore lines and
 * hides the surface/bottom-hole points (per Product). The points are circles, and for the four
 * Create New Well statuses the hexagon symbol (INS-13300).
 * @param {InsetMap} map - The inset's own map
 */
export const styleInsetMainWells = (map: InsetMap): void => {
  if (!map.isStyleLoaded()) return;
  for (const layer of map.getStyle()?.layers ?? []) {
    if (!layer.id.startsWith('wells-v2')) continue;
    try {
      if (layer.type === 'line') {
        map.setPaintProperty(
          layer.id,
          'line-width',
          INSET_MAIN_WELL_LINE_WIDTH
        );
      } else if (
        layer.type === 'circle' ||
        (layer.type === 'symbol' &&
          layer.layout?.['icon-image'] === PRE_PERMIT_HEXAGON_IMAGE)
      ) {
        map.setLayoutProperty(layer.id, 'visibility', 'none');
      }
    } catch {
      // Layer may be mid add/remove during a style change — ignore.
    }
  }
};
